export { default as TaskType } from "./TaskType.vue";

import { useI18n } from "vue-i18n";

export const TaskTypes = Object.freeze({
    NON_RECURRING: "non_recurring",
    RECURRING: "recurring",
});

export function useTaskType() {
    const { t } = useI18n();

    const taskTypes = [
        {
            options: [
                {
                    id: TaskTypes.NON_RECURRING,
                    label: t("components.filters.task_type.non_recurring"),
                },
                {
                    id: TaskTypes.RECURRING,
                    label: t("components.filters.task_type.recurring"),
                },
            ],
        },
    ];

    return {
        taskTypes,
    };
}
